const ENV = {
    OPTIMIZELY_KEY: 'VPud2c1vCrz5CccRE2TQ1',
};

export { ENV };
//# sourceMappingURL=environment.dev.js.map
